import { render } from "./HosManage.vue?vue&type=template&id=46dd4098"
import script from "./HosManage.vue?vue&type=script&lang=js"
export * from "./HosManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__